import Link from 'next/link';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { getCollectionRoute } from '@/shared/helpers';
import { getCollectionNameByDtoId, SJDatabase } from '@/shared/lib/sj-orm';
import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';
import { Icon } from '@/shared/uikit/Icon';

const NOT_FOUND_STRING = 'Not found';

type DtoIdFieldViewProps = {
  ids: string | string[];
  emptyText: string;
  sjDb: SJDatabase;
  isPdf?: boolean;
};

export const renderDtoIdFieldView = ({
  ids,
  sjDb,
  emptyText = '-',
  isPdf,
}: DtoIdFieldViewProps) => {
  const isEmpty = (typeof ids !== 'string' && !Array.isArray(ids)) || !ids || ids.length === 0;

  if (isEmpty) {
    return emptyText;
  }

  const idsList = Array.isArray(ids) ? ids : [ids];

  const dtoLinks = idsList
    .map((id) => {
      const collection = getCollectionNameByDtoId(id);
      if (!collection) return emptyText;

      const item = sjDb.collections[collection]?.findById(id) as BaseDto & {
        name?: string;
        firstName?: string;
        nickname?: string;
        nickName?: string;
      };

      if (!item) return emptyText;

      const name = item?.name || item?.firstName || item?.nickName || item?.nickname;
      const url = getCollectionRoute(collection, id);

      return !isPdf ? (
        <StyledLink
          style={{ display: 'inline-flex', alignItems: 'center' }}
          key={item.id}
          href={url}
        >
          <Icon name="file-text" size="s16" />
          {name}
        </StyledLink>
      ) : (
        name
      );
    })
    .filter(Boolean);

  if (!dtoLinks.length) {
    return NOT_FOUND_STRING;
  }

  return <div style={{ display: 'flex', gap: 8 }}> {dtoLinks}</div>;
};

const StyledLink = styled(Link)`
  &&& {
    color: ${COLORS.systemSky200};

    &:hover {
      color: ${COLORS.systemSky300};
    }
  }
`;
